import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { WidgetType } from 'domain/entity/widget';
import { WidgetIssue } from 'domain/entity/widgetIssue';

export type WidgetIssuesSelection = {
    widgetId: string;
    widgetType: WidgetType;
    widgetTitle?: string;
    page?: number;
    issues: WidgetIssue[];
};

type WidgetIssuesState = {
    selection: WidgetIssuesSelection | null;
};

type WidgetIssuesDispatch = {
    openWidgetIssues: (selection: WidgetIssuesSelection) => void;
    closeWidgetIssues: () => void;
};

const WidgetIssuesStateContext = createContext({} as WidgetIssuesState);
const WidgetIssuesDispatchContext = createContext({} as WidgetIssuesDispatch);

export const useWidgetIssues = (): WidgetIssuesState => useContext(WidgetIssuesStateContext);
export const dispatchWidgetIssues = (): WidgetIssuesDispatch => useContext(WidgetIssuesDispatchContext);

export const WidgetIssuesProvider = ({ children }: { children: ReactNode }): React.ReactElement => {
    const [selection, setSelection] = useState<WidgetIssuesSelection | null>(null);

    const dispatchValue = useMemo(
        () => ({
            openWidgetIssues: (next: WidgetIssuesSelection) => setSelection(next),
            closeWidgetIssues: () => setSelection(null),
        }),
        []
    );
    const stateValue = useMemo(() => ({ selection }), [selection]);

    return (
        <WidgetIssuesStateContext.Provider value={stateValue}>
            <WidgetIssuesDispatchContext.Provider value={dispatchValue}>{children}</WidgetIssuesDispatchContext.Provider>
        </WidgetIssuesStateContext.Provider>
    );
};
